import { Instance } from 'mobx-state-tree';
import { PharmacyStore } from '../../../store';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { IItemRendererProps } from '@blueprintjs/select';
import { MenuItem } from '@blueprintjs/core';
import { TLCode } from '../../../common/enums';
import withTranslate, { WithTranslateProps } from '../WithTranslate';
import { Pharmacy } from '../../../store/models/Pharmacy';
import FormField from './FormField';
import Select from 'react-select';

interface PharmacyFormFieldProps extends WithTranslateProps {
  PharmacyStore?: Instance<typeof PharmacyStore>;
  pharmacyList?: Array<Instance<typeof Pharmacy>>;
  getRef?: (input) => void;
  getLabel?: (pharmacy: Instance<typeof Pharmacy>) => string;
  name?: string;
  pharmacyId?: number;
  onPharmacyIdChanged?: (pharmacyId: number) => void;
}

@inject('PharmacyStore')
@observer
class PharmacyFormField2 extends React.Component<PharmacyFormFieldProps> {
  state = {
    selectedValue: null,
  };

  componentDidMount(): void {
    if (this.props.pharmacyId) {
      this.setState({ selectedValue: this.props.pharmacyId });
    }
  }

  componentDidUpdate(): void {
    if (this.props.pharmacyId && this.props.pharmacyId !== this.state.selectedValue) {
      this.setState({ selectedValue: this.props.pharmacyId });
    }
  }

  renderPharmacyMenuItem(item: Instance<typeof Pharmacy>, { handleClick, index, modifiers }: IItemRendererProps) {
    if (modifiers.matchesPredicate) {
      return (
        <MenuItem
          key={`pharmacy-${index}`}
          active={modifiers.active}
          onClick={handleClick}
          text={item.apbNumber + ' - ' + item.name!}
        />
      );
    } else {
      return null;
    }
  }

  filterPharmacy = (query, pharmacy) => {
    return (
      (pharmacy.apbNumber + ' - ' + pharmacy.name! + ' - ' + pharmacy.city)
        .toLowerCase()
        .indexOf(query.toLowerCase()) >= 0
    );
  };

  render() {
    const { PharmacyStore, getRef, onPharmacyIdChanged, pharmacyId, ...otherProps } = this.props;
    let { pharmacyList } = this.props;
    if (pharmacyList == null) {
      pharmacyList = PharmacyStore!.dataList;
    }

    return (
      <FormField label={TLCode.PHARMACY} name={this.props.name ? this.props.name : 'pharmacyId'} {...this.props}>
        {({ input: { onChange, ...rest } }) => {
          let value: any = null;
          if ((rest.value && rest.value !== '') || pharmacyId !== undefined) {
            const selectedValue =
              rest.value && rest.value !== ''
                ? pharmacyList!.find((elem) => elem.pharmacyId === rest.value)
                : pharmacyList!.find((elem) => elem.pharmacyId === pharmacyId);
            if (selectedValue) {
              value = {
                value: selectedValue.pharmacyId,
                label: this.props.getLabel
                  ? this.props.getLabel(selectedValue)
                  : '(' +
                    selectedValue.level +
                    ') - ' +
                    selectedValue.apbNumber +
                    ' ' +
                    selectedValue.name +
                    ' @ ' +
                    selectedValue.zipCode +
                    ' ' +
                    selectedValue.city,
              };
            }
          }

          return (
            <Select
              onChange={(item) => {
                this.setState({ selectedValue: item });
                onChange(item.value);
                if (onPharmacyIdChanged) onPharmacyIdChanged(item.value);
              }}
              options={pharmacyList!.map((elem) => {
                return {
                  value: elem.pharmacyId,
                  label: this.props.getLabel
                    ? this.props.getLabel(elem)
                    : '(' +
                      elem.level +
                      ') - ' +
                      elem.apbNumber +
                      ' ' +
                      elem.name +
                      ' @ ' +
                      elem.zipCode +
                      ' ' +
                      elem.city,
                };
              })}
              {...rest}
              value={value}
              ref={(input) => {
                if (getRef) getRef(input);
              }}
            />
          );
        }}
      </FormField>
    );
  }
}

export default withTranslate(PharmacyFormField2);
